const EmptyContent = () => {
  return <></>;
};

export default EmptyContent;
